import { createSlice } from '@reduxjs/toolkit'

const initialState: {
  loading: boolean
  categoryMap: Record<string, { id: number; value: string; label?: string }[]>
} = {
  loading: false,
  categoryMap: {},
}

const categoryDropdownSlice = createSlice({
  name: 'categoryDropdown',
  initialState: initialState,
  reducers: {
    setCategoryLoading: (state, action) => {
      state.loading = action.payload.loading
    },

    getCategoryDropdownData: (state, _action) => {
      return state
    },
    resetCategoryDropdownData: (state) => {
      state.categoryMap = {}
    },
    updateAllCategoryDropdownData: (state, action) => {
      /*
      {
        "id": 1367,
        "category": "CS Effective Timeframe",
        "value": "1 Month",
        "label": null,
        "v_order": null
      }
      */
      action.payload.allOptions.forEach(
        (option: { category: string; id: number; value: string }) => {
          const categoryKey = option.category

          state.categoryMap[categoryKey] ??= []

          const exists = state.categoryMap[categoryKey].some(
            (item) => item.id === option.id
          )

          if (!exists) {
            state.categoryMap[categoryKey].push(option)
          }
        }
      )
      Object.keys(state.categoryMap).forEach((categoryKey) => {
        state.categoryMap[categoryKey].sort((a, b) =>
          a.value.localeCompare(b.value)
        )
      })
    },
    updateCategoryDropdownData: (state, action) => {
      state.categoryMap[action.payload.categoryKey] = action.payload.options
    },
  },
})

export const {
  getCategoryDropdownData,
  updateCategoryDropdownData,
  updateAllCategoryDropdownData,
  setCategoryLoading,
  resetCategoryDropdownData,
} = categoryDropdownSlice.actions
export default categoryDropdownSlice.reducer
